import { lazy } from "react";
import url from "src/config/search.json";

const RandomPointsGeneratorPage = lazy(
  () => import("src/pages/data-generator/random-points")
);
const LineGeneratorPage = lazy(() => import("src/pages/data-generator/line"));
const PolygonGeneratorPage = lazy(
  () => import("src/pages/data-generator/polygon")
);
const ExportLayerToFilePage = lazy(
  () => import("src/pages/data-generator/export-layer-to-file")
);
const PickLatLongPage = lazy(
  () => import("src/pages/data-generator/pick-lat-long")
);

const keys = Object.keys(url.services);
const currentkey = keys[2];
export const dataGeneratorRoutes = [
  {
    path: currentkey,
    children: [
      {
        path: url.services.Data_Generator[0].url,
        element: <RandomPointsGeneratorPage />,
      },
      {
        path: url.services.Data_Generator[1].url,
        element: <LineGeneratorPage />,
      },
      {
        path: url.services.Data_Generator[2].url,
        element: <PolygonGeneratorPage />,
      },
      {
        path: url.services.Data_Generator[3].url,
        element: <PickLatLongPage />,
      },
      {
        path: url.services.Data_Generator[4].url,
        element: <ExportLayerToFilePage />,
      },
    ],
  },
];
